import { fetchWrapper } from '@/_helpers';

export const jobPostApi = {
    getJobPosts: ({ teamId, archived = false, page = 1, searchText }) =>
        fetchWrapper.get(
            `job-posts?${teamId ? `team=${teamId}` : ''}&archived=${archived}&page=${page || 1}${searchText ? `&searchText=${searchText}` : ''}&limit=10`
        ),
    createJobPost: (data) => fetchWrapper.post('job-posts', data),
    getJobPostById: (id) => fetchWrapper.get(`job-posts/${id}`),
    updateJobPost: (id, data) => fetchWrapper.put(`job-posts/${id}`, data),
    deleteJobPost: (id) => fetchWrapper.delete(`job-posts/${id}`),
    archiveJobPost: (id) => fetchWrapper.put(`job-posts/${id}/archive/true`),
    unarchiveJobPost: (id) => fetchWrapper.put(`job-posts/${id}/archive/false`),
    getJobPostQuestions: (id) => fetchWrapper.get(`job-posts/${id}/questions`),
    updateJobPostQuestions: (id, questions) => fetchWrapper.patch(`job-posts/${id}/questions`, { questions }),
};
